import styled from '@emotion/styled'
import { Accordion, Box, Typography } from '@mui/material'
import theme from 'theme'

export const InfoCard = styled(Box)`
  padding: ${theme.spacing.xSmall}px;
  background-color: ${theme.colors.labelCardBg};
  border-radius: ${theme.attributes.borderRadius.tertiary};

  html[data-theme='light'] & {
    background-color: #fafafb;
    border: 1px solid ${theme.colors.strokeSecondary};
  }
`

export const InfoCardInner = styled(Box)`
  padding: ${theme.spacing.xSmall}px ${theme.spacing.medium}px;
`

export const InfoTitle = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xLarge};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 24px;
  letter-spacing: 0.1px;
  color: ${theme.colors.menuItemText};
`

export const InfoDescription = styled(Typography)`
  margin-top: ${theme.spacing.xSmall}px !important;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 20px;
  letter-spacing: 0.25px;
  color: ${theme.colors.devicesSecondaryText};
`

export const DetailsAccordion = styled(Accordion)`
  background-color: transparent;
  box-shadow: none;
  margin: 0 !important;

  &:before {
    display: none;
  }

  &.Mui-expanded {
    margin: 0 !important;
  }

  .MuiAccordionSummary-root {
    min-height: unset;
    padding: ${theme.spacing.xSmall}px ${theme.spacing.medium}px;

    &.Mui-expanded {
      min-height: unset;
    }
  }

  .MuiAccordionSummary-content {
    margin: 0;

    &.Mui-expanded {
      margin: 0;
    }
  }

  .MuiAccordionSummary-expandIconWrapper {
    svg {
      color: ${theme.colors.devicesSecondaryText};
    }
  }

  .MuiAccordionDetails-root {
    display: flex;
    padding: ${theme.spacing.small}px ${theme.spacing.medium}px ${theme.spacing.lg}px ${theme.spacing.medium}px;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.spacing.medium}px;
    align-self: stretch;
  }
`

export const DetailsLabel = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xLarge};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 24px;
  letter-spacing: 0.1px;
  color: ${theme.colors.menuItemText};
`

export const ScopeRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm}px;
`

export const ScopeIconWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: ${theme.attributes.borderRadius.secondary};
  background: ${theme.colors.devicesRowHoverBg};

  svg {
    stroke: ${theme.colors.devicesSecondaryText};
  }

  html[data-theme='light'] & {
    svg {
      stroke: ${theme.colors.caption};
    }
  }
`

export const ScopeLabel = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  color: ${theme.colors.devicesSecondaryText};
  line-height: 22px;
`

export const ScopeValue = styled(Typography)`
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
  line-height: 20px;
`
